export class SubAndChildCategory {
  constructor(id = "", name = "", slug_url = "", childCategory = []) {
    this.id = id;
    this.name = name;
    this.slug_url = slug_url;
    this.childCategory = childCategory;
  }
}
